import React from "react";

export default function AuthFooter() {
  return (
    <footer className="relative z-10 w-full border-t border-slate-200/50 bg-transparent py-6 text-center dark:border-white/10">
      <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
        © {new Date().getFullYear()} Pilot Link USA. All rights reserved.
      </p>
    </footer>
  );
}